import { useMemo } from "react";
import { queries, roundedHoursAgo } from "../../../shared/queries";
import { useQuery } from "../../hooks/useQuery";

export const MONITOR_STATS_WINDOW_HOURS = 30 * 24;

// Panels must read through this hook (same query, same args) so the tab
// registers one Zero query instead of one per panel.
export function useMonitorSpaceWorkflows() {
  const since = roundedHoursAgo(MONITOR_STATS_WINDOW_HOURS);
  const [spaceRows, result] = useQuery(
    queries.monitorSpaceWorkflowRuns({ since })
  );

  const workflows = useMemo(
    () =>
      (spaceRows ?? []).flatMap(({ workflows: spaceWorkflows, ...space }) =>
        spaceWorkflows.map((workflow) => ({ ...workflow, space }))
      ),
    [spaceRows]
  );

  return { workflows, result };
}

export type MonitorSpaceWorkflow = ReturnType<
  typeof useMonitorSpaceWorkflows
>["workflows"][number];
